// Global state to track which component is active
let activeComponent = null;

document.addEventListener("DOMContentLoaded", () => {
  const header = document.getElementById("main-header");
  // Mobile menu functionality
  const mobileMenuBtn = document.getElementById("mobile-menu-btn");
  const mobileMenuDropdown = document.getElementById("mobile-menu-dropdown");
  const mobileMenuClose = document.querySelector(".close_mobile_menu");

  // Mobile search functionality
  const searchBtn = document.getElementById("search-btn");
  const searchForm = document.getElementById("header__search");
  const searchInput = searchForm?.querySelector(".header__search-input");

  // Cart Drawer
  const cartDrawer = document.getElementById("CartDrawer");

  // Controlling Main overlay
  const mainOverlay = document.querySelector(".main__overlay");

  // Open/Close Menu
  const toggleMenu = () => {
    const isOpening = !mobileMenuBtn.classList.contains("active");
    mobileMenuBtn.classList.toggle("active");
    mobileMenuDropdown.classList.toggle("active");

    if (isOpening) {
      if (typeof window.resetMobileNavPanels === "function") {
        window.resetMobileNavPanels();
      }
      if (activeComponent === "search") closeSearch();
      if (activeComponent === "cart") closeCartDrawer();

      // Add overlay click handler when opening
      mainOverlay.addEventListener("click", toggleMenu);

      // Set active component
      activeComponent = "menu";
    } else {
      // Remove overlay click handler when closing
      mainOverlay.removeEventListener("click", toggleMenu);

      activeComponent = null;
      if (typeof window.resetMobileNavPanels === "function") {
        window.resetMobileNavPanels();
      }
    }

    if (mainOverlay.classList.contains("active")) {
      mainOverlay.classList.remove("active");
    } else {
      mainOverlay.classList.add("active");
    }

    document.body.style.overflow = mobileMenuBtn.classList.contains("active")
      ? "hidden"
      : "";
  };

  mobileMenuClose.addEventListener("click", toggleMenu);

  // Keep track of overlay click handler
  let overlayClickHandler = null;

  const showSearch = () => {
    if (activeComponent === "cart") closeCartDrawer();
    if (activeComponent === "menu") toggleMenu();

    if (document.body.overflow != "hidden") {
      document.body.style.overflow = "hidden";
    }

    // Use requestAnimationFrame for smoother animation
    requestAnimationFrame(() => {
      searchForm.classList.add("active");
      searchBtn.classList.add("active");
      mainOverlay.classList.add("active");
      searchInput.focus();
      adjustOverlay();
      activeComponent = "search";

      // Add overlay click handler only once
      if (!overlayClickHandler) {
        overlayClickHandler = (e) => {
          // Only close if clicking directly on overlay (not children)
          if (e.target === mainOverlay) {
            closeSearch(false);
          }
        };
        mainOverlay.addEventListener("click", overlayClickHandler);
      }
    });
  };

  const closeSearch = () => {
    if (!searchForm.classList.contains("active")) return;

    // Reset search UI
    searchForm.classList.remove("active");
    mainOverlay.classList.remove("active");
    searchBtn.classList.remove("active");
    searchInput.value = "";
    resetOverlay();
    document.body.style.overflow = "";
    activeComponent = null;

    // Remove overlay click handler
    if (overlayClickHandler) {
      mainOverlay.removeEventListener("click", overlayClickHandler);
      overlayClickHandler = null;
    }
  };

  // Initialize Menu Drawer event listeners
  if (mobileMenuBtn && mobileMenuDropdown) {
    mobileMenuBtn.addEventListener("click", toggleMenu);
  }

  // Initialize Search Drawer event listeners
  if (searchBtn && searchForm) {
    searchBtn.addEventListener("click", () => {
      searchForm.classList.contains("active") ? closeSearch() : showSearch();
    });
  }

  //Open Cart Drawer
  const openCartDrawer = () => {
    if (cartDrawer.classList.contains("open")) return;
    cartDrawer.classList.add("open");
    mainOverlay.classList.add("active");
    adjustOverlay();

    if (activeComponent === "search") closeSearch();
    if (activeComponent === "menu") toggleMenu();

    activeComponent = "cart";

    if (document.body.overflow != "hidden") {
      document.body.style.overflow = "hidden";
    }

    // Add overlay click handler only once
    if (!overlayClickHandler) {
      overlayClickHandler = (e) => {
        if (e.target === mainOverlay) {
          closeCartDrawer();
        }
      };
      mainOverlay.addEventListener("click", overlayClickHandler);
    }
  };

  //Close Cart Drawer
  const closeCartDrawer = () => {
    if (!cartDrawer.classList.contains("open")) return;
    cartDrawer.classList.remove("open");
    mainOverlay.classList.remove("active");
    resetOverlay();
    document.body.style.overflow = "";
    activeComponent = null;

    // Remove overlay click handler
    if (overlayClickHandler) {
      mainOverlay.removeEventListener("click", overlayClickHandler);
      overlayClickHandler = null;
    }
  };

  // Close search when clicking outside (header/announcement)
  document.addEventListener("mousedown", (e) => {
    if (activeComponent !== "search") return;

    const searchElements = [
      document.querySelector(".header__search-container"),
      document.getElementById("search-btn"),
    ];

    const clickedInsideSearch = searchElements.some(
      (el) => el && (el === e.target || el.contains(e.target))
    );

    if (!clickedInsideSearch) {
      closeSearch(header.contains(e.target));
    }
  });

  // Modified escape key handler
  const handleEscapeKey = (e) => {
    if (e.key === "Escape") {
      if (activeComponent === "menu") {
        toggleMenu();
      } else if (activeComponent === "search") {
        const isMouseOverHeaderNow = header.matches(":hover");
        closeSearch(isMouseOverHeaderNow);
      } else if (activeComponent === "cart") {
        closeCartDrawer();
      } else if (activeComponent === "video-popup") {
        closeVideoPopup();
      } else if (activeComponent === "filter") {
        closeFilterDrawer();
      }
    }
  };

  // Add escape key listener once
  document.addEventListener("keydown", handleEscapeKey);

  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.activeComponent = activeComponent;

  window.openFilterDrawer = openFilterDrawer;
  window.closeFilterDrawer = closeFilterDrawer;

  window.toggleMenu = toggleMenu;
});

const closeAllPopups = (activeComponent) => {
  if (activeComponent === "localization") {
    closeCartDrawer();
    closeFilterDrawer();
    closeSearch();
    closeVideoPopup();

    const mobileMenuBtn = document.getElementById("mobile-menu-btn");
    if (mobileMenuBtn.classList.contains("active")) toggleMenu();
  }
};

const openFilterDrawer = () => {
  const filterDrawer = document.querySelector(".filters-drawer");
  if (!filterDrawer) return;

  filterDrawer.classList.add("open");
  document.body.style.overflow = "hidden";
  mainOverlay.classList.add("active");
  mainOverlay.addEventListener("click", closeFilterDrawer);
  activeComponent = "filter";
};

const closeFilterDrawer = () => {
  const filterDrawer = document.querySelector(".filters-drawer");
  if (!filterDrawer) return;

  filterDrawer.classList.remove("open");
  document.body.style.overflow = "";
  mainOverlay.classList.remove("active");

  mainOverlay.removeEventListener("click", closeFilterDrawer);
  activeComponent = null;
};
